class klaviyoBackInStockForm extends HTMLElement {
    constructor() {
        super()
        this.form = this.querySelector("form")
        this.email_input = this.querySelector("input[type='email']")
        this.variant_input = this.querySelector("input[name='variant_id']")
        this.submit_button = this.querySelector("button[type='submit']")
        this.customer_id = "UMPbTR" 
        this.success_message_template = this.querySelector(".success-message--template").content
        this.variant_data = this.dataset.variantJson ? JSON.parse(this.dataset.variantJson) : null
        this.form_id = this.dataset.productFormId || null
        this._observer = null;
    }
    connectedCallback() {
        if (this.product_form_el){
            this.product_form_el.addEventListener("change", this.handleVariantChange.bind(this))
            this._observer = new MutationObserver(() => {
                this.handleVariantChange();
            });
            this._observer.observe(this.product_form_el, { childList: true, subtree: true, attributes: true });
        }

        this.form.addEventListener("submit", this.submit.bind(this))
        if(this.form_id){
            const option_buttons = document.querySelectorAll(`#${this.form_id} button[data-option]`)
        }
    }
    
  handleVariantChange() {
    const variant_id = this.current_variant_id;
    if (!variant_id || !this.variant_input) return;
    if (String(variant_id) === String(this.variant_input.value)) return;
    this.variant_input.value = variant_id;
    const availability = this.availability;
    if (availability !== null) {
      if (availability) this.hide();
      else this.show();
    }
  }
    get product_form_el() {
        if (!this.form_id) return null;
        return document.getElementById(this.form_id);
    }
    get availability() {
        if (!this.variant_data) return null
        const variant_id = this.variant_input.value
        const variant = this.variant_data.find(variant => variant.variant_id === variant_id)
        return variant?.available ?? null
    }
    get current_variant_id() {
        const pf = this.product_form_el;
        if (!pf) return null;
        const idInput = pf.querySelector("input[name='id']");
        return idInput?.value || null;
    }
    disconnectedCallback() {
        if (this.product_form_el) this.product_form_el.removeEventListener("change", this.handleVariantChange.bind(this))
        if (this.form) this.form.removeEventListener("submit", this.submit.bind(this));
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
    }
    submit(event) {
        event.preventDefault()
        // this.submit_button.classList.add("active") 

        let request = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                // id is optional, only include if you have it
                                email: this.email_input.value
                            }
                        }
                    },
                    channels: ["EMAIL"]
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${this.variant_input.value}`
                        }
                    }
                }
            }
        }
        let requestOptions = {
            method: 'post',
            headers: {
                accept: 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
                revision: '2025-04-15',
            },
            body: JSON.stringify(request),
        };
        this.email_input.disabled = true;
        this.submit_button.disabled = true;
        // Clone and insert the success message, then focus it for screen readers
        const successMessage = this.success_message_template.cloneNode(true).children[0];
        successMessage.setAttribute("role", "status");
        successMessage.setAttribute("aria-live", "polite");
        successMessage.setAttribute("tabindex", "-1");
        this.appendChild(successMessage);
        this.form.style.display = "none";
        successMessage.focus();
        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.customer_id}`, requestOptions)
            .then(response => {
                console.log('Success:', response);
            })
            .catch(error => console.log('error', error));
    }
    show(){
        this.removeAttribute("hidden")
    }
    hide(){
        this.setAttribute("hidden","")
    }
}
if (!customElements.get("klaviyo-back-in-stock")) {
    customElements.define("klaviyo-back-in-stock", klaviyoBackInStockForm)
}

